import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import {
  DeleteOperator,
  fetchOperator,
  GetAccountStatusCount,
} from "../../../../api/Api";
import CustomTable from "../../../../components/Table/CustomTable";
import PaginationComponent from "../../../../components/Pagination/PaginationComponent";
import CustomModal from "../../../../components/Modal/CustomModal";
import AddOperator from "./addOperator";

const ManageOperator = () => {
  const location = useLocation();
  const serviceData = location.state;
  console.log("Received service data:", serviceData);
  const navigate = useNavigate();
  const handleBack = () => {
    navigate(-1); // This will navigate back to the previous page
  };
  const [currentPage, setCurrentPage] = useState(0);
  const [addProductModal, setAddProductModal] = useState(false);
  const [stateData, setStateData] = useState({
    tableLoader: true,
    countLoader: true,
    filterClick: true,
    nameFilterChecked: false,
    dateTimeFilterChecked: false,
    updatedByFilterChecked: false,
  });
  const [tableData, setTableData] = useState(null);
  const [enabledColumns, setEnabledColumns] = useState([]);
  const [totalPages, setTotalPages] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [pageSizeArr] = useState([10, 20, 30, 40, 50]);
  const [editCpModal, setEditCpModal] = useState(false);
  const [viewCpModal, setViewCpModal] = useState(false);
  const [changePasswordModal, setChangePasswordModal] = useState(false);
  const [tabVal, setTabVal] = useState(1);
  const [tabs, setTabs] = useState([]);
  const [rowData, setRowData] = useState(null);
  const [totalElements, setTotalElements] = useState(0);
  const [paginationData, setPaginationData] = useState({
    totalElements: 0,
    totalPages: 0,
    pageSize: 10,
    currentPage: 0
  });

  const getAllData = async () => {
    setStateData((prev) => ({ ...prev, tableLoader: true }));
    try {
      let payload = {
        pageNo: paginationData.currentPage,
        pageSize: paginationData.pageSize,
        id: serviceData?.id,
      };
      const response = await fetchOperator(payload);

      if (response?.statusDescription?.status === 200) {
        const contentWithActions = response?.operatorResponse?.content?.map(item => ({
          ...item,
          actions: response?.action
        }));

        setPaginationData({
          totalElements: response?.operatorResponse?.page?.totalElements,
          totalPages: response?.operatorResponse?.page?.totalPages,
          pageSize: response?.operatorResponse?.page?.size,
          currentPage: response?.operatorResponse?.page?.number
        });

        setTableData(contentWithActions);
        setEnabledColumns(response?.enabledColumns);
      } else {
        setTableData([]);
        setPaginationData({
          totalElements: 0,
          totalPages: 0,
          pageSize: 10,
          currentPage: 0
        });
        setEnabledColumns([]);
      }
    } catch (error) {
      console.error("Error fetching operators:", error);
      Swal.fire("Error!", "Failed to fetch operators", "error");
    } finally {
      setStateData((prev) => ({ ...prev, tableLoader: false }));
    }
  };

  const handlePageChange = (pageNumber) => {
    setPaginationData(prev => ({
      ...prev,
      currentPage: pageNumber
    }));
  };

  const handlePageSizeChange = (newSize) => {
    setPaginationData(prev => ({
      ...prev,
      pageSize: Number(newSize),
      currentPage: 0 // Reset to first page when changing page size
    }));
  };

  const handleAction = (action, rowData, newStatus) => {
    console.log("rowData", rowData, action);
    setRowData(rowData);
    if (action.sequence == 2) {
      setViewCpModal(true);
    } else if (action?.sequence == 4) {
      setChangePasswordModal(true);
    } else if (action?.sequence == 3) {
      setEditCpModal(true);
    } else if (action?.id == 148) {
      // Delete operator confirmation
      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to delete this operator?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          try {
            let payload = {
              id: rowData?.id,
            };
            const response = await DeleteOperator(payload);
            if (response?.statusDescription?.status === 200) {
              return response;
            } else {
              throw new Error(response?.statusDescription?.description || 'Failed to delete operator');
            }
          } catch (error) {
            Swal.showValidationMessage(
              `Delete failed: ${error.message}`
            );
          }
        },
        allowOutsideClick: () => !Swal.isLoading()
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: "Deleted!",
            text: "Operator has been deleted successfully.",
            icon: "success"
          }).then(() => {
            getAllData(); // Refresh the table after successful deletion
          });
        }
      });
    }
  };

  const getCount = async () => {
    setStateData((prev) => ({ ...prev, countLoader: true }));
    const response = await GetAccountStatusCount();
    setStateData((prev) => ({ ...prev, countLoader: false }));
    console.log("responseCount", response);
    if (response?.statusDescription?.status === 200) {
      setTabs(response?.userCountResponeList);
    } else {
      setTabs([]);
      Swal.fire("Error!", "Something went wrong. Please try again.", "error");
    }
  };

  useEffect(() => {
    getCount();
  }, []);

  useEffect(() => {
    getAllData();
  }, [paginationData.currentPage, paginationData.pageSize]);

  return (
    <div class="content-wrapper">
      {/* <nav aria-label="breadcrumb" className="back_bread">
        <ol className="breadcrumb breadcrumb_bg">
          <li className="breadcrumb-item">
            <a
              className="breadcrumb_1  backbread_a"
              onClick={handleBack}
              style={{ cursor: "pointer" }}
            >
              <i className="fas fa-arrow-left mr-2"></i>Back
            </a>
          </li>
        </ol>
      </nav> */}
      <section class="content">
        <div class="row">
          <div class="col-md-12">
            <div class="box">
              <div class="box-header mb-0 pb-0">
                <nav aria-label="breadcrumb" className="back_bread m-0 p-0">
                  <ol className="breadcrumb breadcrumb_bg mb-0">
                    <li className="breadcrumb-item">
                      <a
                        className="breadcrumb_1  backbread_a new_back"
                        onClick={handleBack}
                        style={{ cursor: "pointer" }}
                      >
                        <i className="fas fa-arrow-left mr-2"></i>Back
                      </a>
                    </li>
                  </ol>
                </nav>
                <div class="row mb-0">
                  <div class="col-md-8 col-12">
                    <nav aria-label="breadcrumb">
                      <ol class="breadcrumb breadcrumb_bg">
                        <li class="breadcrumb-item">
                          <a class="breadcrumb_1">Manage Operator</a>
                        </li>
                        <li
                          class="breadcrumb-item active breadcrumb_2 d-flex align-items-center"
                          aria-current="page"
                        >
                         <span>Operator List</span>
                        </li>
                      </ol>
                    </nav>
                  </div>
                  <div class="col-md-4 col-12 mt_3 d-flex align-items-center justify-content-end">
                    <div class="btn-group float-right">
                      <button
                        type="button"
                        class="btn btn-primary btn-raised btn-flat create_cp"
                        onClick={() => setAddProductModal(true)}
                      >
                        Add Operator
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="box-body pt-0">
                <div class="tab-content pt-0" id="myTabContent">
                  <div
                    class="tab-pane fade show active pt-2"
                    id="home"
                    role="tabpanel"
                    aria-labelledby="home-tab"
                  >
                    {stateData?.tableLoader ? (
                      <div className="container">
                        <div className="row g-3">
                          <div className="col-12">
                            <div className="placeholder-glow">
                              <div
                                className="placeholder col-12 rounded"
                                style={{ height: "40px" }}
                              ></div>
                            </div>
                          </div>
                          {[...Array(5)].map((_, index) => (
                            <div className="col-12" key={index}>
                              <div className="placeholder-glow">
                                <div
                                  className="placeholder col-12 rounded"
                                  style={{ height: "50px" }}
                                ></div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    ) : !stateData?.tableLoader && tableData?.length > 0 ? (
                      <>
                        <div className="form-group d-flex align-items-center justify-content-between gap-2 records">
                          <div className="d-flex align-items-center">
                            <span>Show</span>
                            <select
                              className="form-select count_select mx-2"
                              value={paginationData.pageSize}
                              onChange={(e) => handlePageSizeChange(e.target.value)}
                              style={{ width: "auto" }}
                            >
                              {[10, 20, 30, 40, 50].map((size) => (
                                <option key={size} value={size}>
                                  {size}
                                </option>
                              ))}
                            </select>
                            <span>entries</span>
                          </div>
                          <div>
                            <button
                              type="button"
                              className="btn btn-primary ref_but"
                              onClick={getAllData}
                            >
                              Refresh &nbsp;
                              <i className="fas fa-sync ms-auto"></i>
                            </button>
                          </div>
                        </div>

                        <div id="table">
                          <CustomTable
                            data={tableData}
                            enabledColumns={enabledColumns}
                            onAction={handleAction}
                            currentPage={paginationData.currentPage}
                            pageSize={paginationData.pageSize}
                            renderAction={(row) => (
                              <div className="d-flex gap-2 justify-content-center">
                                {row.actions?.map((action, index) => (
                                  <button
                                    key={index}
                                    className={`btn btn-link p-0 ${action.colorCode}`}
                                    title={action.titleName}
                                    onClick={() => handleAction(action, row)}
                                  >
                                    <i className={`${action.iconName} fa-lg`} style={{ fontSize: '16px' }}></i>
                                  </button>
                                ))}
                              </div>
                            )}
                          />
                        </div>

                        <div className="d-flex justify-content-between align-items-center flex-column flex-md-row w-100" id="pagination">
                          <div className="mr-3 line_pagination px-2 px-md-0">
                            Showing {paginationData.currentPage * paginationData.pageSize + 1} to{" "}
                            {Math.min(
                              (paginationData.currentPage + 1) * paginationData.pageSize,
                              paginationData.totalElements
                            )}{" "}
                            of {paginationData.totalElements} entries
                          </div>
                          <div className="pages">
                            <PaginationComponent
                              currentPage={paginationData.currentPage}
                              onPageChange={handlePageChange}
                              totalPages={paginationData.totalPages}
                            />
                          </div>
                        </div>
                      </>
                    ) : !stateData?.tableLoader && tableData?.length == 0 ? (
                      <div className="d-flex justify-content-center">
                        <h4>No data found</h4>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* create cp modal */}
      <CustomModal
        show={addProductModal}
        onHide={() => {
          setAddProductModal(false);
        }}
        title="Add Product"
        size="lg"
        dialogClassName="custom-modal-class"
      >
        <div style={{ maxHeight: "70vh", overflowY: "auto", overflowX: "hidden" }}>
          <AddOperator
            setAddProductModal={setAddProductModal}
            getAllData={getAllData}
            operatorData={rowData}
            countryId={serviceData?.id}
          />
        </div>
      </CustomModal>

      {/* edit cp modal */}
      {/* <CustomModal
        show={editCpModal}
        onHide={() => {
          setEditCpModal(false);
        }}
        title="Edit Package Details"
        size="xl"
        dialogClassName="custom-modal-class"
      >
        <div style={{ maxHeight: "70vh", overflowY: "auto", overflowX: "hidden", height: "70vh" }}>
          <EditPackage
            setEditCpModal={setEditCpModal}
            getAllData={getAllData}
            editData={rowData}
          />
        </div>
      </CustomModal> */}

      {/* view cp modal */}
      {/* <CustomModal
        show={viewCpModal}
        onHide={() => {
          setViewCpModal(false);
        }}
        title="View Service Detail"
        size="xl"
        dialogClassName="custom-modal-class"
      >
        <ViewPackage viewData={rowData} />
      </CustomModal> */}

      {/* Change Password request cp modal */}

    </div>
  );
};

export default ManageOperator;
